import React from "react";
import { observer } from "mobx-react";
import { DateTime } from "luxon";

import { ISOToDisplayCode, getDisplayedAmount } from "@utils";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function CashoutHistoryTableRow(props: {
	count: number;
	rowData: { timestamp: string; cashoutValue: number };
}) {
	const time = DateTime.fromISO(props.rowData.timestamp, {
		zone: "utc",
	})
		.toLocal()
		.toLocaleString(DateTime.DATETIME_SHORT);

	return (
		<tr className="table--primary__body__row">
			<td className="table--primary__body__data u-type--left">
				{props.count}
			</td>
			<td className="table--primary__body__data u-type--left">{time}</td>
			<td className="table--primary__body__data u-type--right">
				{getDisplayedAmount(
					props.rowData.cashoutValue,
					ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)
				)}
			</td>
		</tr>
	);
});
